/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';

/**
 * This component is used to display an entitlement plan status
 *
 * @category ui.components.organizations.entitlements
 * @exports EntitlementPlanCard
 */
const __vue_script__ = {
    name: 'EntitlementPlanCard',

    components: { Badge },

    props: {
        plan: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            animatedProgress: 0
        };
    },

    computed: {
        /**
         * Changes the class name based on the progress level.
         *
         * @returns {String} the class name used for the progress ring
         */
        progressRingClass() {
            if (this.progress <= 10) {
                return 'progress-danger';
            }

            if (this.progress <= 30) {
                return 'progress-warning';
            }

            return 'progress-normal';
        },

        /**
         * Calculates the progress percentage.
         *
         * @returns {Number} the progress percentage
         */
        progress() {
            return (this.plan.available / this.plan.total) * 100;
        }
    },

    mounted() {
        setTimeout(() => (this.animatedProgress = 100 - this.progress), 500);
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "entitlement-plan-card card" }, [
    _c(
      "header",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: _vm.$t("organizations.entitlements.plans.usage", [
              _vm.plan.available,
              _vm.$t(
                "organizations.entitlements.plans.types." +
                  _vm.plan.product_type
              ),
              _vm.plan.total,
            ]),
            expression:
              "$t('organizations.entitlements.plans.usage', [plan.available, $t(`organizations.entitlements.plans.types.${plan.product_type}`), plan.total])",
          },
        ],
      },
      [
        _c("progress-ring", {
          class: _vm.progressRingClass,
          attrs: { progress: _vm.animatedProgress, radius: 32, stroke: 12 },
        }),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.plan.available)),
        ]),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v("/" + _vm._s(_vm.plan.total)),
        ]),
      ],
      1
    ),
    _c(
      "section",
      [
        _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.plan.id))]),
        _c(
          "badge",
          {
            class:
              _vm.plan.product_type === "subscription" ? "success" : "warn",
          },
          [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "organizations.entitlements.plans.types." +
                    _vm.plan.product_type
                )
              )
            ),
          ]
        ),
        _c("div", { staticClass: "id" }, [
          _vm._v(_vm._s(_vm.$t("organizations.entitlements.plans.id")) + ":"),
          _c("span", [_vm._v(" " + _vm._s(_vm.plan.id))]),
        ]),
        _c("div", { staticClass: "expiration" }, [
          _vm._v(
            _vm._s(_vm.$t("organizations.entitlements.plans.expires")) + ":"
          ),
          _vm.plan.valid_to
            ? _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$utils.time.tsToShortDateFormat(_vm.plan.valid_to)
                    )
                ),
              ])
            : _c("span", [_vm._v(" -")]),
        ]),
      ],
      1
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/organizations/entitlements/EntitlementPlanCard.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__